import api from './api';

export interface User {
  userId: string;
  lmsPlatformId: string;
  email: string;
  username: string;
  createdDate: string;
  syncedDate: string;
  tags: string[] | string; // Can be array or string (JSON string)
  entraObjectId?: string;
  isSuspended: boolean;
}

/**
 * Service for fetching user data from the API
 */
export const userService = {
  /**
   * Get all users
   * @returns Promise with the list of users
   */
  getUsers: async (): Promise<User[]> => {
    try {
      const response = await api.get('/users');
      
      // Check if the response has the expected structure
      if (response.data && Array.isArray(response.data.data)) {
        return response.data.data;
      } else if (response.data && typeof response.data === 'object') {
        // If data is not an array but an object with numeric keys (array-like)
        if (Object.keys(response.data).some(key => !isNaN(Number(key)))) {
          return Object.values(response.data);
        }
      }
      
      // Fallback to empty array if data structure is unexpected
      console.warn('Unexpected API response structure:', response.data);
      return [];
    } catch (error) {
      console.error('Error fetching users:', error);
      throw error;
    }
  },

  /**
   * Get a specific user by ID
   * @param userId The ID of the user to get
   * @returns Promise with the user data
   */
  getUser: async (userId: string): Promise<User> => {
    try {
      const response = await api.get(`/users/${userId}`);
      return response.data.data;
    } catch (error) {
      console.error(`Error fetching user ${userId}:`, error);
      throw error;
    }
  }
};

export default userService;
